export default __webpack_public_path__ + "e97a96abcc884209109880bf1b34e4a0.svg";